import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import ParticlesAuth from "../ParticlesAuth";

// Import Images — tái dùng ảnh minh hoạ lỗi có sẵn (chưa có ảnh riêng cho 403)
import error from "../../../assets/images/error.svg";
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('authentication_inner');

const AccessDenied = () => {
  document.title = st('403_khong_co_quyen_truy_cap_text');
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content mt-lg-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center pt-4">
                  <div className="">
                    <img
                      src={error}
                      alt=""
                      className="error-basic-img move-animation"
                    />
                  </div>
                  <div className="mt-n4">
                    <h1 className="display-1 fw-medium">403</h1>
                    <h3 className="text-uppercase">
                      {st('ban_khong_co_quyen_truy_cap_title')}
                    </h3>
                    <p className="text-muted mb-4">
                      {st('vui_long_lien_he_quan_tri_text')}
                    </p>
                    <Link to="/login" className="btn btn-success">
                      <i className="mdi mdi-home me-1"></i>{st('ve_trang_chu_button')}
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default AccessDenied;
